export interface Message {
  id: string;
  content: string;
  owner: string;
}

export enum MessageTypes {
  MESSAGE = 'MESSAGE',
  MENTION = 'MENTION',
  IMAGE = 'IMAGE',
  GIF = 'GIF',
};

export enum ActionTypes {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
};

export interface ChatRoomMessage {
  id: string;
  ownerId: string;
  ownerProfile: {
    id: string;
    name: string;
  };
  content?: string;
  resource?: string;
  sentAt: string;
  type: MessageTypes;
}

export type NotificationMessage = {
  chatRoomId: string;
  id: string;
  ownerId: string;
  action: string;
  seen?: boolean;
  notificationId?: string;
} & ChatRoomMessage;

export interface ListChatRoomMessagesResponse {
  listChatRoomMessages: {
    items: ChatRoomMessage[];
    nextToken: string;
  }
}

export interface ChatRoom {
  id: string;
  title: string;
  soundEnabled: boolean;
  disabled: boolean;
  notificationsEnabled: boolean;
  lastMessageSeen?: {
    id: string;
    sentAt: string;
    content: any;
    type: MessageTypes;
  };
  lastMessage?: {
    id: string;
    sentAt: string;
    content: any;
    ownerProfile: {
      id: string;
      name: string;
    }
    type: MessageTypes;
  } | NotificationMessage;
}

export interface ListChatRoomsResponse {
  listChatRooms: {
    items: ChatRoom[];
  };
}

export interface Mention {
  id: string;
  name: string;
  ownerId: string;
}

export interface MutedUser {
  name: string;
  owner: string;
}

export interface ListMutedUsersResponse {
  listMutedUsers: MutedUser[];
}

export interface UnmuteUserResponse {
  unmuteChatUser: {
    status: string;
  };
}

export enum InputModes {
  TEXT,
  EMOJI,
  GIPHY,
  IMAGE,
};

export interface Attachment {
  preview: string;
  name: string;
  uploadUrl: string;
  key: string;
  mediaId: string;
}
